(function () {
  'use strict';

  angular
  .module('directive.debug', [])

  /* @ngInject */
  .directive('debug', function () {
    return {
      restrict: 'E',
      template: '<div ng-include="debugCtrl.template"></div>',
      controllerAs: 'debugCtrl',
      /* @ngInject */
      controller: ["$scope", "$document", function ($scope, $document) {
        var ctrl = this,
          ctrlKey = false,
          altKey = false,
          active = false;

        ctrl.isMenuCollapse = false;
        ctrl.toggleMenuCollapse = function () {
          ctrl.isMenuCollapse = !ctrl.isMenuCollapse;
        };

        $document.on('keydown', function (event) {
          if (event.ctrlKey) ctrlKey = true;
          if (event.altKey) altKey = true;
          if (ctrlKey && altKey && event.keyCode === 68) {
            active = !active;
            $scope.$apply(function () {
              ctrl.template = active ? '/Template/Debug/Index' : '';
            });
          }
        });
        $document.on('keyup', function () {
          ctrlKey = altKey = false;
        });
      }]
    };

  });

})();
